import { ArticleCam } from './article-cam';

export class Article {
  constructor(
    public hash?: string,
    public articleNumber?: string,
    public description?: string,
    public routeDescription?: string,
    public extendedDescription?: string,
    public cam?: ArticleCam,
    public hasSpecialTool?: boolean,
  ) { }

  clone() {
    return new Article(
      this.hash,
      this.articleNumber,
      this.description,
      this.routeDescription,
      this.extendedDescription,
      this.cam,
      this.hasSpecialTool
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/article.ts